import { render } from "./LocationListRow.vue?vue&type=template&id=cd639ca2&ts=true"
import script from "./LocationListRow.vue?vue&type=script&lang=ts"
export * from "./LocationListRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__